@if (account) {
  <div class="account">
    <a
        class="unread-badge"
        (click)="openNotifications()">
      <fs-badge
        [text]="unreadNotifications"
        [color]="unreadNotifications ? '#F30000' : '#d6d6d6'"
        [size]="20">
      </fs-badge>
    </a>
    <button
        class="account-menu"
        mat-icon-button
        [fsMenuTriggerFor]="accountMenu">
      <fs-badge
        [image]="account.avatar?.tiny"
        [size]="35">
      </fs-badge>
    </button>
    <fs-menu #accountMenu>
      <ng-template
          fs-menu-item
          [link]="'/account'">
        Account settings
      </ng-template>
      <ng-template
          fs-menu-item
          (click)="signout()">
        Sign out
      </ng-template>
    </fs-menu>
  </div>
}